/** نقش صف در این نشست: فقط وقتی سیستم ورود به صف فعال است پرسیده می‌شود. */

export type QueueLoginRole = 'booking' | 'outside';

const ROLE_KEY = 'admin_queue_login_role';
const ROLE_CONFIRMED_KEY = 'admin_queue_role_confirmed';

export function getQueueLoginRole(): QueueLoginRole | null {
  const value = sessionStorage.getItem(ROLE_KEY);
  if (value === 'booking' || value === 'outside') return value;
  return null;
}

export function setQueueLoginRole(role: QueueLoginRole): void {
  sessionStorage.setItem(ROLE_KEY, role);
  sessionStorage.setItem(ROLE_CONFIRMED_KEY, '1');
}

export function isQueueRoleConfirmedThisSession(): boolean {
  return sessionStorage.getItem(ROLE_CONFIRMED_KEY) === '1';
}

export function clearQueueLoginRole(): void {
  sessionStorage.removeItem(ROLE_KEY);
  sessionStorage.removeItem(ROLE_CONFIRMED_KEY);
}

export function isBookingQueueRole(): boolean {
  return getQueueLoginRole() === 'booking';
}
